import axios from "axios";
import constants from "config/constants";

const AxiosInstance = axios.create({
  baseURL: constants.baseUrlLocale,
});

AxiosInstance.interceptors.request.use((req) => {
  const user = localStorage.getItem("user");
  const savedUser = user ? JSON.parse(user) : null;
  const accessToken = localStorage.getItem("accessToken");

  // Use token from user object or from separate accessToken storage
  const token = savedUser?.accessToken || accessToken;

  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }

  req.headers["ngrok-skip-browser-warning"] = true;

  return req;
});

AxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if (status === 401) {
      localStorage.removeItem("user");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("isGoForSubscription");
      localStorage.removeItem("subModalSkipCount");
      window.location.href = "/";
    }

    return Promise.reject(error);
  },
);

export default AxiosInstance;
